import moment from "moment";
import { BudgetPeriod } from "@/services/cloudchipr.api";
import { formatDate } from "@/utils/helpers/date-time/datetime-format";

export const getBudgetDetailsDateToFromPeriod = (
  startDate: string,
  endDate?: string | null,
  period?: BudgetPeriod,
) => {
  const date = moment(startDate);
  const now = moment();

  if (period === "custom") {
    return now.isAfter(endDate)
      ? endDate
      : formatDate(now, { type: "yearMonthDay" });
  }

  if (period === "monthly") {
    return formatDate(date.endOf("month"), { type: "yearMonthDay" });
  }

  if (period === "quarterly") {
    return formatDate(date.add(2, "month").endOf("month"), {
      type: "yearMonthDay",
    });
  }

  if (period === "annually") {
    return formatDate(date.endOf("year"), { type: "yearMonthDay" });
  }

  return startDate;
};
